import { useState } from 'react';
import LookupTable from './LookupTable';
import LookupRecordModal from './LookupRecordModal';
import AddAliasesModal from './AddAliasesModal';

const ManagedLookup = ({ definition, columns, fields, page, allowAddAliases = false }) => {
    const [operation, setOperation] = useState(null);
    return <>
        <LookupTable definition={definition} columns={columns} rows={page.rows} loading={page.loading} remote={page}
            onAddAliases={allowAddAliases ? record => setOperation({ type: 'aliases', record }) : undefined}
            onAdd={() => setOperation({ type: 'add' })}
            onEdit={record => setOperation({ type: 'edit', record })}
            onDelete={record => setOperation({ type: 'delete', record })} />
        {operation?.type === 'aliases' ? <AddAliasesModal definition={definition} fields={fields} record={operation.record}
            onChanged={page.retry}
            onClose={() => setOperation(null)} onSuccess={() => { setOperation(null); page.retry(); }} />
            : operation && <LookupRecordModal definition={definition} fields={fields} operation={operation}
            onClose={() => setOperation(null)} onSuccess={() => { setOperation(null); page.retry(); }} />}
    </>;
};
export default ManagedLookup;
